import { Trash2 } from "lucide-react";

export function Section({ title, children }) {
  return (
    <div className="bg-white border border-black/10 rounded-lg p-5 sm:p-6">
      <h3 className="font-oswald font-semibold text-league-ink text-lg mb-4">{title}</h3>
      {children}
    </div>
  );
}

export function DeleteBtn({ onClick, testid }) {
  return (
    <button
      onClick={onClick}
      data-testid={testid}
      className="p-2 rounded-md text-league-red/70 transition-colors duration-200 hover:bg-league-red hover:text-white"
      aria-label="Delete"
    >
      <Trash2 size={15} />
    </button>
  );
}
